import React from 'react';
import * as css from './EmptyCard.css';

interface EmptyCardProps {
    image: string;
    title: string;
    description?: string;
    children: React.ReactNode;
    imageAlt?: string;
    bordered?: boolean;
}

function EmptyCard({image, title, description, children, imageAlt = '', bordered = true}: EmptyCardProps) {
    return (
        <css.card $bordered={bordered}>
            <css.content>
                <css.image src={image} alt={imageAlt} />
                <css.title>{title}</css.title>
                {description && <css.description>{description}</css.description>}
            </css.content>
            <css.actions>{children}</css.actions>
        </css.card>
    );
}

export default EmptyCard;
